async function netRequests() {
  const PROGRAMS = "https://hermes.smile-tech.study/api/v1/project/1/programs/regional";

  /* Запрос на получение json */
  async function getJson(patch) {
    if (!patch) return;

    let result;

    try {
      /* На данный момент не все браузеры поддерживают AbortController */
      if ("AbortController" in window) {
        const response = await fetchWithTimeout(patch, {
          timeout: 3000,
        });
        result = await response.json();
      } else {
        const response = await fetch(patch);
        result = await response.json();
      }

      return result;
    } catch (error) {
      console.log(error.name === "AbortError");
    }
  }

  /* Функция прерывания запроса через определенный промежуток времени на основе AbortController  */
  async function fetchWithTimeout(resource, options = {}) {
    const { timeout = 6000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);

    return response;
  }

  /* Передача массива программ фед операторов */
  return await getJson(PROGRAMS);
}

export default netRequests;
